export abstract class ValueObject<T> {
  protected readonly value: T;

  constructor(value: T) {
    this.value = value;
  }

  static validate(input: any): boolean {
    return true;
  }

  toString(): string {
    return `${this.value}`;
  }
}
